<template>
  <div class="noresult-container p-5">
    <div class=" d-flex justify-content-center ">
      <lottie-player
        src="https://assets2.lottiefiles.com/datafiles/vhvOcuUkH41HdrL/data.json"
        background="transparent"
        speed="1"
        style="width: 180px; height: 180px;"
        loop
        autoplay
      ></lottie-player>
    </div>
    <p class="text-center text-muted">No Result</p>
  </div>
</template>
<script>
export default {};
</script>

<style>
.empty {
  pointer-events: none;
  user-select: none;
}
</style>